import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export default {
  Container
};



// WEBPACK FOOTER //
// ./src/pages/App/styles.js